import axiosInstance from '../api/axios';

const getTextoBase = async (username,token,studyId,nodeId) => {

    const response = await axiosInstance.post("/report/gettextobase",
        {},
        {
            params: {
                username,
                token,
                studyId,
                nodeId
            }
        });

    try {
        
            const result = await response.data;        
            var resultJSON = JSON.parse(result);                    
            return resultJSON;
        

    } catch (err) {
        console.error("ERRO [Report, getTextoBase]: Falha ao obter resultados da operação.", err);
        if (!err?.response) {
            alert("Falha de comunicação com o servidor ao obter os resultados. Por favor, contate o serviço técnico da DATA E.");
        }
    }
}

export default getTextoBase;